import { observer } from "mobx-react-lite";
import { ConfirmDialog } from "@/components/common";
import { useTran } from "@/hooks";
import { useCarbonTargetsStore } from "../../hooks";

const TargetSettingsDeleteDialog = observer(() => {
  const { t } = useTran();
  const store = useCarbonTargetsStore();

  return (
    <ConfirmDialog
      open={Boolean(store.deleteTarget)}
      onOpenChange={(openState) => {
        if (!openState) store.closeDeleteDialog();
      }}
      title={t("Delete carbon target setting")}
      description={t("This will mark your carbon target as deleted.")}
      confirmLabel={t("Delete")}
      cancelLabel={t("Cancel")}
      loading={store.deleting}
      tone="danger"
      onConfirm={() => {
        store.deleteCarbonTarget(t);
      }}
    />
  );
});

export default TargetSettingsDeleteDialog;
